export default __webpack_public_path__ + "static/ferpa-logo-7fcbaa612cb72b450e50cb581117b02b.png";